<template>
  <AccountComplianceAlert
    v-for="compliance in compliances"
    :key="compliance.name"
    :compliance="compliance"
  />
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { ComplianceName } from '@/gql/graphql'
import AccountComplianceAlert from '@/components/compliances/alerts/AccountComplianceAlert.vue'
import AccountType from '@/utils/AccountType'

const props = defineProps<{
  complianceNames: ComplianceName[]
}>()

const emit = defineEmits<{
  (e: 'has-compliances', hasCompliances: boolean): void
}>()

const isSupportedAccountType =
  AccountType.isFreelancer(currentAccountType) || AccountType.isRecruiter(currentAccountType)

const { result } = useQuery(
  graphql(`
    query AccountComplianceAlerts($id: ID!, $names: [ComplianceName!]) {
      compliance(id: $id, names: $names) {
        name
        applicable
        completed
        ...AccountComplianceAlert
      }
    }
  `),
  {
    id: currentAccount.globalId,
    names: props.complianceNames,
  },
  {
    clientId: 'publicApi',
    enabled: isSupportedAccountType,
  },
)

const compliances = computed(
  () => result.value?.compliance?.filter((comp) => comp.applicable && !comp.completed) ?? [],
)

watch(compliances, (newCompliances) => {
  emit('has-compliances', newCompliances.length > 0)
})
</script>
